import React from 'react';
import Geolocation from 'react-geolocation';
import Slider from 'rc-slider';
import {SpinLoader} from '../../../components/Loader';
import _ from "lodash";
import Dropdown from "../../../components/Dropdown";
import Icon from "../../../components/Icon";

class Geoloc extends React.Component {
    constructor(props) {
        super(props);

        this.locationDistance = {
            0: '0km',
            25: '25km',
            50: '50km',
            75: '75km',
            100: '100km',
            125: 'Partout',
        };
        this.state = {
            toggleGeoloc: true,
            geoLoading: false,
            geoError: {},

            toggleCity: false,
            indexCityList: 0,
            searchCity: "",
            CityList: [],
            mouseInPerimeter: false
        };
        this.getCurrentPosition = this.getCurrentPosition.bind(this);


        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleSearchCity = this.handleSearchCity.bind(this);
        this.handleCity = this.handleCity.bind(this);
        this.getCities = _.debounce(this.getCities, 300);
        this.handleResetGeo = this.handleResetGeo.bind(this);

        document.addEventListener("keydown", this.handleKeyPress);
        this.getCities();
    }

    getCurrentPosition(pos) {
        let locationDistance = this.props.locationDistance === 125 ? 50 : this.props.locationDistance;
        this.setState({
            geoLoading: false,
        });
        this.props.handleLocationSwitch({
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude,
            locationDistance,
            isUsingGeo: true
        });
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyPress);
        this.setState({toggleCity: false, searchCity: '', cityList: []});
    }

    getCities() {
        let query = {searchCities: this.state.searchCity, sort : "name", limit : 5};
        if(query.searchCities && query.searchCities.length >= 3){
            this.props.fetchLocationSearchCities(query);
        }
    }

    handleSearchCity(event) {
        this.setState({searchCity: event.target.value, toggleCity: true}, () => this.getCities());
    }

    handleKeyPress({key}) {
        if (key === "Enter" && this.state.toggleCity && this.props.cities.length >= 1) {
            let firstCity = this.props.cities;

            let selectCity = firstCity[this.state.indexCityList] || firstCity[0];
            if (selectCity) {
                this.handleCity(selectCity);
            }

        }

        if (key === "ArrowDown" && this.state.toggleCity) {
            let cities = this.props.cities;
            let count = cities.length - 1;

            let index = this.state.indexCityList;
            index++;
            if (index > count) {
                index = 0;
            }
            this.handleIndexCity(index);
        }
        if (key === "ArrowUp" && this.state.toggleCity) {
            let cities = this.props.cities;
            let count = cities.length - 1;
            let index = this.state.indexCityList;
            index--;
            if (index < 0) {
                index = count;
            }
            this.handleIndexCity(index);
        }

        if (key === "Escape" && this.state.toggleCity) {
            this.setState({searchCity: "", toggleCity: false, indexCityList: 0});
        }
    }

    handleIndexCity(index) {
        this.setState({indexCityList: index});
    }

    handleMouseEnter(index) {
        this.setState({mouseInPerimeter: true, indexCityList: index});
    }

    handleMouseLeave(index) {
        this.setState({mouseInPerimeter: false, indexCityList: index});
    }

    handleCity(city){
        this.setState({searchCity: "", toggleCity: false, indexCityList: 0});
        this.props.handleLocationCity(city, this.props.locationDistance);
        if(!city._id){
            this.getCities();
            //let isToggle = _.get(response, "payload.setting.displayBigPlan") || false

        }
    }

    handleResetGeo() {

        this.setState({
            geoLoading: true
        }, () => {
            this.setState({geoLoading: false});
            this.props.handleLocationSwitch({
                isUsingGeo: false,
                latitude: 0,
                longitude: 0,
            });
        });

    }

    render() {
        return (
            <div className="localisation-filter">
                <div className="geoloc-title row full justify-space-between align-center"
                     onClick={() => this.setState({toggleGeoloc: !this.state.toggleGeoloc})}>
                    <h6>Localisation :&nbsp;
                        {this.props.locationDistance === 125 ? "Partout" : `${this.props.isUsingGeo ? "Votre position" : this.props.currentCity && this.props.currentCity.name} avec un rayon de ${this.props.locationDistance}km`}
                    </h6>
                </div>
                <div className="row wrap">
                    <div className="localisation-sub-block">
                        <ul className="filter mb-8 mx-8">
                            <Geolocation
                                lazy
                                render={({getCurrentPosition}) => (
                                    <li className={`geoloc-button ${this.props.isUsingGeo ? 'active' : ''}`}
                                        onClick={() => this.props.isUsingGeo ? this.handleResetGeo() : this.setState({
                                            geoLoading: true,
                                            geoError: {}
                                        }, () =>{getCurrentPosition(); this.handleCity({_id : null, name : "", parentTypeId : {}})})}>{this.props.isUsingGeo ? 'Effacer ma position' : 'Me localiser'} {this.state.geoLoading && (
                                        <SpinLoader className="small ml-8"/>)}</li>
                                )}
                                timeout={60000}
                                onSuccess={(pos) => this.getCurrentPosition(pos)}
                                onError={(error) => this.setState({geoLoading: false, geoError: error})}
                            />
                            <li className={!this.props.isUsingGeo ? 'active' : ''}
                                onClick={() => this.handleResetGeo()}>Choisir ma position
                            </li>
                        </ul>
                        {this.state.geoError && this.state.geoError.message && (
                            <div className="warning">Une erreur s'est produite. Veuillez vérifier la configuration
                                de votre navigateur avant de ressayer.</div>)}
                        <div className={`localisation-select ${this.props.isUsingGeo ? 'not-used' : ''}`}>
                            {_.get(this.props,"currentCity._id") ? (
                                <div className="currentCity">
                                    <div>
                                        {this.props.currentCity.name} {_.get(this.props.currentCity, 'parentTypeId.name') ? ` - ${this.props.currentCity.parentTypeId.name}` : null}
                                    </div>
                                    <span onClick={() => this.handleCity({_id : null, name : "", parentTypeId : {}})}><Icon type="close"/></span>
                                </div>
                            ) : !this.props.isUsingGeo ?(
                                <input type={"text"}
                                       className={"search-city-input"}
                                       placeholder={"Taper le nom de votre ville"}
                                       value={this.state.searchCity}
                                       onChange={this.handleSearchCity}
                                       onFocus={() => this.setState({toggleCity: true})}
                                       onBlur={() => !this.state.mouseInPerimeter ? this.setState({toggleCity: false}) : ""}
                                />
                            ) : null}



                            <div className={"cities-in-room"}>
                                <Dropdown className="tag-city" align="right toggle-city"
                                          toggle={this.state.toggleCity}>
                                    {Array.isArray(this.props.cities) && this.props.cities.map((item, index) => (
                                        <li
                                            key={index}
                                            onClick={() => this.handleCity(item)}
                                            onMouseEnter={() => this.handleMouseEnter(index)}
                                            onMouseLeave={() => this.handleMouseLeave(index)}
                                            className={this.state.indexCityList === index ? 'cities active' : ''}
                                        >
                                            {item.name} {_.get(item, 'parentTypeId.name') ? ` - ${item.parentTypeId.name}` : null}
                                        </li>
                                    ))}
                                </Dropdown>

                            </div>

                        </div>
                    </div>
                    <div className="localisation-sub-block">
                        <div className="my-16 lines-arround">choisir la distance</div>
                        <div className="slider-container">
                            <Slider
                                min={0}
                                max={125}
                                step={null}
                                marks={this.locationDistance}
                                defaultValue={this.props.locationDistance}
                                value={this.props.locationDistance}
                                onChange={this.props.handleLocationDistance}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Geoloc;